import { onBeforeUnmount, ref, type Ref } from 'vue'

import { parseApiError } from '@/shared/utils/apiErrorParser'

/**
 * F1 — лимиты кода из письма/Telegram (контракт ошибок:
 * sprint-14-otp-channel-choice/verification-code-limits-followups.md).
 *
 * - 32 `GUARD_CONFIRM_ACTION_CODE_ATTEMPTS`: пятая ошибка сожгла код. Любой
 *   следующий ввод, даже верный, получит 32 — нужен новый код.
 * - 33 `GUARD_CODE_TOO_MANY_REQUESTS`: много выдач кода или проверок с одного
 *   IP. Новый код не выдадут, пока не пройдёт окно сервера (15 минут).
 *
 * Код приложения (TOTP, 31) сюда не относится — его разбирает LoginTotpStep.
 */
export const CODE_BURNED = 32
export const CODE_REQUESTS_THROTTLED = 33
/** Окно сервера для 33 — то же, что в его тексте ошибки. */
export const CODE_REQUESTS_WAIT_MS = 15 * 60_000

export type CodeLimit = 'burned' | 'throttled'

export function codeLimitOf(error: unknown): CodeLimit | null {
  const code = parseApiError(error).code
  if (code === CODE_BURNED) return 'burned'
  if (code === CODE_REQUESTS_THROTTLED) return 'throttled'

  return null
}

/** Пауза повторной отправки кода после 33. Таймер снимается вместе с компонентом. */
export function useCodeRequestPause(): { paused: Ref<boolean>; pause: () => void } {
  const paused = ref(false)
  let timer: ReturnType<typeof setTimeout> | undefined

  const pause = (): void => {
    clearTimeout(timer)
    paused.value = true
    timer = setTimeout(() => { paused.value = false }, CODE_REQUESTS_WAIT_MS)
  }
  onBeforeUnmount(() => clearTimeout(timer))

  return { paused, pause }
}
